import { useLayoutEffect } from "react";
import WithModal from "@components/HOC/withModals";
import { MODALS_ENUM } from "@constants/Modals";
import { IMinerStatusesModal } from "./MinerStatusesModal.props";
import styles from "./MinerStatusesModal.module.scss";
import MinersTable from "@components/Pages/Machines/MinersTable/MinersTable";
import { useDispatch } from "react-redux";
import { clearMTFilters, setCurrentFilter } from "@store/filters/actions";
import { MINER_STATUSES_E } from "@constants/MinerStatuses";

function MinerStatusesModal(props: IMinerStatusesModal) {

  const dispatch = useDispatch();

  useLayoutEffect(() => {
    dispatch(setCurrentFilter("SET_LOCATION_FILTER", props.locationId));
    if (props.buildingId) {
      dispatch(setCurrentFilter("SET_BUILDING_FILTER", props.buildingId));
    }
    if (props.status) {
      const st = {
        ok: MINER_STATUSES_E.OK,
        low: MINER_STATUSES_E.LOW,
        offline: MINER_STATUSES_E.OFF,
      };
      dispatch(setCurrentFilter("SET_MINER_STATE_FILTER", st[props.status]));
    }
    return () => {
      dispatch(clearMTFilters());
    };
  }, [props.buildingId, props.locationId, props.status]);

  return (
    <div className={styles.wrapper}>
      <MinersTable
        parrentElement={null}
        isMinerStatusesModal
        TAG={`${props.locationName ? props.locationName : "Location-" + props.locationId}_${props.status}`}
      // refresh={control.refresh}
      />
    </div>
  );
}

export default WithModal(MODALS_ENUM.MINER_STATUSES_MODAL, MinerStatusesModal, {
  style: { width: "95%" },
});
